import logger from '../logger/BatchedLogger';

// API Interceptor for automatic logging of API calls
export const setupApiInterceptors = (axiosInstance) => {
    // Request interceptor
    axiosInstance.interceptors.request.use(
        (config) => {
            const startTime = Date.now();
            config.metadata = { startTime };

            // Skip logging for log-batch endpoints to prevent recursive logging
            if (!config.url?.includes('/log-batch') && !config.url?.includes('/log')) {
                // Only log in development/local environments to reduce log volume
                if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'local') {
                    logger.debug(`API Request: ${config.method?.toUpperCase()} ${config.url}`, {
                        category: 'api_request',
                        method: config.method,
                        url: config.url,
                        headers: config.headers,
                        data: config.data,
                        environment: process.env.NODE_ENV
                    });
                }
            }

            return config;
        },
        (error) => {
            logger.error('API Request Error', {
                category: 'api_request_error',
                message: error.message,
                stack: error.stack,
                environment: process.env.NODE_ENV
            });
            return Promise.reject(error);
        }
    );

    // Response interceptor
    axiosInstance.interceptors.response.use(
        (response) => {
            const endTime = Date.now();
            const duration = response.config.metadata?.startTime
                ? endTime - response.config.metadata.startTime
                : 0;

            // Skip logging for log-batch endpoints to prevent recursive logging
            if (!response.config.url?.includes('/log-batch') && !response.config.url?.includes('/log')) {
                // Log in development/local environments, or for slow/error responses in any environment
                const isDevelopment = process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'local';
                const shouldLog = isDevelopment || duration > 2000 || response.status >= 400;

                if (shouldLog) {
                    logger.logApiCall(
                        response.config.method?.toUpperCase() || 'UNKNOWN',
                        response.config.url || '',
                        response.status,
                        duration,
                        {
                            responseSize: JSON.stringify(response.data).length,
                            responseHeaders: response.headers,
                            environment: process.env.NODE_ENV
                        }
                    );
                }
            }

            return response;
        },
        (error) => {
            const endTime = Date.now();
            const duration = error.config?.metadata?.startTime
                ? endTime - error.config.metadata.startTime
                : 0;

            const status = error.response?.status || 0;
            const url = error.config?.url || 'unknown';
            const method = error.config?.method?.toUpperCase() || 'UNKNOWN';

            // Skip logging for log-batch endpoints to prevent recursive logging
            // Always log errors, but skip log-batch endpoint errors
            if (!url.includes('/log-batch') && !url.includes('/log')) {
                logger.logApiCall(method, url, status, duration, {
                    errorMessage: error.message,
                    errorCode: error.code,
                    responseData: error.response?.data
                });
            }

            return Promise.reject(error);
        }
    );
};

export default setupApiInterceptors;
